import React, { useEffect } from 'react';
import './ProgressBar.scss';
export function ProgressBar({
  done,
  total,
}: {
  done: number;
  total: number;
}): JSX.Element {
  const [style, setStyle] = React.useState({});
  const procentCalc = (done / total) * 100;
  const procent = procentCalc > 100 ? 100 : procentCalc;

  useEffect(() => {
    const timer = setTimeout(() => {
      const newStyle = {
        opacity: 1,
        width: `${procent}%`,
      };
      setStyle(newStyle);
    }, 200);
    return () => clearTimeout(timer);
  }, [procent]);

  return (
    <div className="ProgressBarDiv">
      <div className="ProgressBar">
        <div className="progress-done-bar" style={style}></div>
        <div className="progress-done-text">
          {done}/{total}
        </div>
      </div>
    </div>
  );
}
